<script lang="ts">
  let { loadingProgress, firstLoadFinish } = $props();

  // Partner configurations
  const partners: Record<string, { title: string; logo: string }> = {
    beeco: {
      title: "Ökos Térkép",
      logo: "/assets/ui-icons/beeco-logo.svg",
    },
    example: {
      title: "Example Map",
      logo: "/assets/ui-icons/beecoin.svg",
    },
  };

  // Style configurations (using hex or Tailwind palette values)
  const styles: Record<
    string,
    {
      primary: string;
      secondary: string;
      glow: string;
      accent: string;
    }
  > = {
    default: {
      primary: "oklch(0.877 0.181 99.6)",
      secondary: "oklch(0.77 0.18 90)",
      glow: "oklch(0.88 0.13 20 / 0.1)",
      accent: "oklch(0.77 0.18 90 / 0.1)",
    },
    emerald: {
      primary: "#10b981", // emerald-500
      secondary: "#4ade80", // green-400
      glow: "rgba(16,185,129,0.1)",
      accent: "rgba(74,222,128,0.1)",
    },
    blue: {
      primary: "#3b82f6", // blue-500
      secondary: "#22d3ee", // cyan-400
      glow: "rgba(59,130,246,0.1)",
      accent: "rgba(34,211,238,0.1)",
    },
    rose: {
      primary: "#f43f5e", // rose-500
      secondary: "#fb7185", // pink-400
      glow: "rgba(244,63,94,0.1)",
      accent: "rgba(251,113,133,0.1)",
    },
  };

  // Get params from URL
  const params = new URLSearchParams(window.location.search);
  const partnerId = params.get("partnerId") ?? "";
  const styleId = params.get("style") ?? "default";

  // Pick configs
  const partner = partners[partnerId] ?? partners["beeco"];
  const style = styles[styleId] ?? styles["default"];
</script>

{#if firstLoadFinish}
  <!-- Map is ready -->
{:else}
  <div
    class="fixed font-sans inset-0 flex items-center justify-center z-50 p-4"
    style="
      --color-primary: {style.primary};
      --color-secondary: {style.secondary};
      --color-glow: {style.glow};
      --color-accent: {style.accent};
    "
  >
    <!-- Dark overlay -->
    <div class="absolute inset-0 bg-black/30 backdrop-blur-sm"></div>

    <!-- Loading card -->
    <div
      class="relative bg-white/80 backdrop-blur-md rounded-3xl shadow-2xl p-8 md:p-12 max-w-md w-full border border-white/50"
    >
      <!-- Animated Logo -->
      <div class="relative mx-auto w-32 h-32 mb-6">
        <img
          src={partner.logo}
          alt="Logo"
          class="w-full h-full object-contain drop-shadow-lg animate-float"
        />
        <!-- Subtle glow effect -->
        <div
          class="absolute inset-0 rounded-full blur-xl animate-pulse"
          style="background-color: var(--color-glow)"
        ></div>
      </div>

      <!-- Loading content -->
      <div class="flex flex-col items-center gap-4">
        <h2
          class="text-2xl font-extrabold font-stretch-125% bg-clip-text text-transparent"
          style="background-image: linear-gradient(to right, var(--color-secondary), var(--color-primary))"
        >
          {partner.title}
        </h2>

        <!-- Progress bar -->
        <div
          class="w-full h-2 bg-black/10 rounded-full overflow-hidden backdrop-blur-sm"
        >
          <div
            class="h-full transition-all duration-500 ease-out rounded-full shadow-sm"
            style="
              width: {loadingProgress}%;
              background-image: linear-gradient(to right, var(--color-secondary), var(--color-primary));
            "
          ></div>
        </div>

        <!-- Progress info -->
        <div class="flex flex-col items-center gap-2">
          <span class="text-4xl font-bold" style="color: var(--color-primary)">
            {Math.round(loadingProgress)}%
          </span>
          <span class="text-sm text-gray-600 font-bold">
            {#if loadingProgress < 70}
              Települések betöltése...
            {:else if loadingProgress < 90}
              Keresési index építése...
            {:else if loadingProgress < 100}
              Térkép inicializálása...
            {:else}
              Indulás...
            {/if}
          </span>
        </div>
      </div>

      <!-- Decorative elements -->
      <div
        class="absolute -top-20 -right-20 w-40 h-40 rounded-full blur-3xl"
        style="background-color: var(--color-glow)"
      ></div>
      <div
        class="absolute -bottom-20 -left-20 w-40 h-40 rounded-full blur-3xl"
        style="background-color: var(--color-accent)"
      ></div>
    </div>
  </div>
{/if}
